module.exports = __webpack_public_path__ + "static/media/split.0016cc26.svg";